import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import TrainingsReportLayer from "../components/TrainingsReportLayer";

const TrainingsReportPage = () => {
    return (
        <MasterLayout>
            <TrainingsReportLayer />
        </MasterLayout>
    );
};

export default TrainingsReportPage;
